import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {AppConfigService} from './app-config.service';
import {isPlatformBrowser} from '@angular/common';
import {ToolsService} from './tools.service';

@Injectable()
export class RequestsTimeInterceptor implements HttpInterceptor {
  private apisToTraceRequestTime: Array<string> = [];

  constructor(
    private tools: ToolsService,
    private appConfigService: AppConfigService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.apisToTraceRequestTime = [
      this.appConfigService.appConfig.wordpressApiUrl,
      this.appConfigService.appConfig.apiUrl,
      this.appConfigService.appConfig.wordpressMenusApiUrl,
    ];
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime: Date = new Date();

    return next.handle(req).pipe(
      tap((response: HttpResponse<any>): HttpResponse<any> | HttpEvent<any> => {
        if (!(response instanceof HttpResponse) || !response.url || isPlatformBrowser(this.platformId)) {
          return response;
        }

        const isUrlIncludedinWhitelist = this.apisToTraceRequestTime.some((current) =>
          response.url.startsWith(current),
        );
        if (!isUrlIncludedinWhitelist) {
          return response;
        }
        this.logRequestTime(req, response, startTime);

        return response;
      }),
    );
  }

  private logRequestTime(request: HttpRequest<any>, response: HttpResponse<any>, startTime: Date): void {
    if (!request || !request.url) {
      return;
    }
    const endTime: Date = new Date();
    const duration: number = (endTime.valueOf() - startTime.valueOf()) / 1000;

    const dataToLog = JSON.stringify({
      duration: `${duration}s`,
      params: request.params.toString(),
      method: request.method,
      requestUrl: request.url,
      responseUrl: response.url,
    }, null, 2).split("\n").join("\r");

    if (duration > 0.5) {
      console.log('API REQUEST DURATION', dataToLog);
    }
  }
}
